import { render, staticRenderFns } from "./IframeCssDetails.vue?vue&type=template&id=2be79d4a&"
import script from "./IframeCssDetails.vue?vue&type=script&lang=js&"
export * from "./IframeCssDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports